// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"76feb016020977b182fa","655":"fbe1982a93976ffaae62"}[chunkId] + ".js";
};